import React from 'react';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useLanguage, LANGUAGES } from '@/contexts/LanguageContext';

const LanguageSelector = ({ 
  variant = 'default', // 'default' | 'compact' | 'icon-only'
  className = '',
  showFlag = true,
  showNativeName = true
}) => {
  const { language, setLanguage } = useLanguage();

  if (variant === 'icon-only') {
    return (
      <Select value={language} onValueChange={setLanguage}>
        <SelectTrigger className={`w-12 h-10 ${className}`} data-testid="language-selector">
          <Globe className="w-4 h-4" />
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <span className="flex items-center gap-2">
                {showFlag && <span>{lang.flag}</span>}
                <span>{showNativeName ? lang.nativeName : lang.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  if (variant === 'compact') {
    return (
      <Select value={language} onValueChange={setLanguage}>
        <SelectTrigger className={`w-20 h-8 text-xs ${className}`} data-testid="language-selector">
          <SelectValue>
            {showFlag && <span className="mr-1">{LANGUAGES.find(l => l.code === language)?.flag}</span>}
            {language.toUpperCase()}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <span className="flex items-center gap-2">
                {showFlag && <span>{lang.flag}</span>}
                <span>{lang.code.toUpperCase()}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  // Default variant
  return (
    <Select value={language} onValueChange={setLanguage}>
      <SelectTrigger className={`w-[140px] ${className}`} data-testid="language-selector">
        <div className="flex items-center gap-2">
          <Globe className="w-4 h-4" />
          <SelectValue>
            {showFlag && <span className="mr-1">{LANGUAGES.find(l => l.code === language)?.flag}</span>}
            {showNativeName 
              ? LANGUAGES.find(l => l.code === language)?.nativeName 
              : LANGUAGES.find(l => l.code === language)?.name}
          </SelectValue>
        </div>
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              {showFlag && <span>{lang.flag}</span>}
              <span>{showNativeName ? lang.nativeName : lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
